module.exports = ".filter-autocomplete-component > button {\n  margin-left: 5px;\n}\n"